import { FifoCache } from './fifo-cache.cls'

/**
 * 
 */
export const NSCaches = { 
  FifoCache
}
